/**
 * UserStatsRefreshRes 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * UserStatsRefreshRes
 */
export interface UserStatsRefreshRes {
  /** 处理的总用户数 */
  total_count?: number
  /** 成功数 */
  success_count?: number
  /** 失败数 */
  failed_count?: number
}

/**
 * UserStatsRefreshRes Schema
 */
export const UserStatsRefreshResSchema: SchemaDefinition = {
  properties: {
    total_count: {
      description: '处理的总用户数',
      format: 'int',
      type: 'integer',
      label: '处理的总用户数',
    },
    success_count: {
      description: '成功数',
      format: 'int',
      type: 'integer',
      label: '成功数',
    },
    failed_count: {
      description: '失败数',
      format: 'int',
      type: 'integer',
      label: '失败数',
    },
  },
  type: 'object',
}
